import InputWrap from '@/components/InputWrap';
import { appRoutes } from '@/router/routes';
import authService from '@/services/auth.service';
import { Button, Form, message } from 'antd';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import './style.scss';

const Login = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();
    const mutation = useMutation(authService.login, {
        onSuccess: (data: any) => {
            setError('');
            if (data.statusCode === 200) {
                setLoading(false);
                if (width >= 767) {
                    message.success('Đăng nhập thành công.');
                }

                localStorage.setItem('token', data?.data);
                window.location.href = appRoutes.MAIN.ROOT;
            } else {
                setLoading(false);
                if (width >= 767) {
                    message.error(data?.data?.message ?? 'Đăng nhập không thành công.');
                }
                setError('Đăng nhập không thành công.');
            }
        },
        onError: (err: any) => {
            setLoading(false);
            if (width >= 767) {
                message.error({ content: err?.data?.message ?? 'Đăng nhập không thành công.' });
            }
            setError('Đăng nhập không thành công.');
        },
    });

    const onSubmit = (dt: any) => {
        if (loading) return;
        setLoading(true);
        mutation.mutate(dt);
    };

    return (
        <div className="login">
            <div className="login__wrap">
                <h1>Login</h1>
                <Form>
                    <Form.Item label="Username" help={errors['username']?.message} colon={false}>
                        <Controller
                            name="username"
                            control={control}
                            rules={{
                                required: 'Vui lòng nhập username',
                            }}
                            render={({ field }) => (
                                <InputWrap
                                    field={field}
                                    placeholder="Username"
                                    onKeyDown={(e: any) => (e.keyCode === 13 ? handleSubmit(onSubmit)() : undefined)}
                                />
                            )}
                        />
                    </Form.Item>
                    <Form.Item label="Password" help={errors['password']?.message} colon={false}>
                        <Controller
                            control={control}
                            name="password"
                            rules={{
                                required: 'Vui lòng nhập mật khẩu',
                            }}
                            render={({ field }) => (
                                <InputWrap
                                    field={field}
                                    type="password"
                                    placeholder="Password"
                                    onKeyDown={(e: any) => (e.keyCode === 13 ? handleSubmit(onSubmit)() : undefined)}
                                />
                            )}
                        />
                    </Form.Item>
                    {error.length > 0 && <p className="login_faild">{error}</p>}
                    <Button htmlType="submit" onClick={handleSubmit(onSubmit)} type="primary">
                        {loading ? 'Đang kiểm tra...' : 'Login'}
                    </Button>
                </Form>
            </div>
        </div>
    );
};

export default Login;
